import { Box, BoxProps } from '@mantine/core';
import { ReactNode } from 'react';

interface HighlightableItemProps extends Omit<BoxProps, 'children'> {
  itemRef: string;
  highlightRef?: string | null;
  children: ReactNode;
}

export function HighlightableItem({ itemRef, highlightRef, children, style, ...boxProps }: HighlightableItemProps) {
  const shouldHighlight = highlightRef === itemRef;

  const highlightStyle: React.CSSProperties = shouldHighlight
    ? {
        backgroundColor: 'rgba(66, 153, 225, 0.1)',
        borderRadius: '8px',
        padding: '4px',
        border: '2px solid rgba(66, 153, 225, 0.3)',
        boxShadow: '0 0 0 2px rgba(66, 153, 225, 0.1)',
      }
    : {};

  return (
    <Box data-timeline-item={itemRef} style={[style, highlightStyle]} {...boxProps}>
      {children}
    </Box>
  );
}
